// Dependency-free word-level diff (LCS) for CMS version compare (read-only).
function tokenize(str) {
  return (str || '').split(/(\s+)/).filter((t) => t !== '');
}

// Strip HTML tags to compare readable text content.
export function stripHtml(html) {
  if (typeof document !== 'undefined') {
    const div = document.createElement('div');
    div.innerHTML = html || '';
    return (div.textContent || div.innerText || '').replace(/\u00a0/g, ' ');
  }
  return (html || '').replace(/<[^>]+>/g, ' ');
}

export function diffWords(oldStr, newStr) {
  const a = tokenize(oldStr);
  const b = tokenize(newStr);
  const m = a.length;
  const n = b.length;
  const dp = Array.from({ length: m + 1 }, () => new Array(n + 1).fill(0));
  for (let i = m - 1; i >= 0; i--) {
    for (let j = n - 1; j >= 0; j--) {
      dp[i][j] = a[i] === b[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
    }
  }
  const out = [];
  let i = 0;
  let j = 0;
  while (i < m && j < n) {
    if (a[i] === b[j]) { out.push({ type: 'equal', value: a[i] }); i++; j++; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) { out.push({ type: 'removed', value: a[i] }); i++; }
    else { out.push({ type: 'added', value: b[j] }); j++; }
  }
  while (i < m) { out.push({ type: 'removed', value: a[i++] }); }
  while (j < n) { out.push({ type: 'added', value: b[j++] }); }
  return out;
}
